import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import toast from "react-hot-toast";
import { createSamvat, getSamvat, updateSamvat } from "./api";

const initialState = {
  samvatData: [],
  fetchLoading: false,
  loading: false,
  error: null,
};

export const createSamvatAsync = createAsyncThunk(
  "samvat/createSamvat",
  async ({ createSamavatValues }, thunkAPI) => {
    try {
      const data = await createSamvat(createSamavatValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to create samvats",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const getSamvatAsync = createAsyncThunk(
  "samvat/getSamvat",
  async (_, thunkAPI) => {
    try {
      const data = await getSamvat();
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to fetch samvats",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

export const updateSamvatAsync = createAsyncThunk(
  "samvat/updateSamvat",
  async ({ updateSamvatValues }, thunkAPI) => {
    try {
      const data = await updateSamvat(updateSamvatValues);
      return data;
    } catch (err) {
      const errorData = err?.response?.data || {
        message: "Failed to update samvat",
      };
      return thunkAPI.rejectWithValue(errorData);
    }
  }
);

const samvatSlice = createSlice({
  name: "samvat",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSamvatAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSamvatAsync.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload?.message);
        // state.samvatData = action.payload.data.results;
      })
      .addCase(createSamvatAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to create samvat";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(getSamvatAsync.pending, (state) => {
        state.fetchLoading = true;
        state.error = null;
      })
      .addCase(getSamvatAsync.fulfilled, (state, action) => {
        state.fetchLoading = false;
        state.samvatData = action.payload.data.results;
      })
      .addCase(getSamvatAsync.rejected, (state, action) => {
        state.fetchLoading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to Fetch samvat";
        state.error = errorMessage;
        toast.error(errorMessage);
      })
      .addCase(updateSamvatAsync.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSamvatAsync.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action.payload?.message);
        // state.samvatData = action.payload.data.results;
      })
      .addCase(updateSamvatAsync.rejected, (state, action) => {
        state.loading = false;
        const errorMessage =
          action.payload?.message ||
          action.error?.message ||
          "Failed to update samvat";
        state.error = errorMessage;
        toast.error(errorMessage);
      });
  },
});

export default samvatSlice.reducer;
